import { counterpartApiConnector } from 'apiConnector/counterpart/counterpart';
import { SelectSearchClient } from 'components/shared/select-search-client';
import type { AnalyticCategoryActions } from 'models';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import type { WorkspaceWithProductSelector } from 'state/workspaces/workspaces/workspaces.model';
import styled from 'styled-components';
import { httpClient } from 'utils/http/httpClient';

interface ClientSelector {
  selectedClient: Nullable<ISalesCounterpart>;
  workspaceType: WorkspaceWithProductSelector;
  onBackClick: () => void;
  onCancelClick: () => void;
  onClientSelected: (client: ISalesCounterpart | null) => void;
}

export const counterpartApi = counterpartApiConnector(httpClient);
export function ClientSelector({
  selectedClient,
  workspaceType,
  onBackClick,
  onCancelClick,
  onClientSelected,
}: ClientSelector) {
  const onClientSearch = useCallback(() => {
    logAnalytics.trackEvent(
      `Primary market product selector ${workspaceType}` as keyof AnalyticCategoryActions,
      'Search for client',
    );
  }, [workspaceType]);

  return (
    <div className="card h-100">
      <Div className="card-header pb-3">
        <Button
          type="button"
          className="btn btn-lg btn-flat-secondary btn-icon-start btn-icon-end"
          onClick={onBackClick}
        >
          <em className="icon">arrow_back</em>
          <FormattedMessage id="back" />
        </Button>
        <H5 className="m-0">
          <FormattedMessage id="productSelector.selectClient" />
        </H5>
        <Dummy />
      </Div>
      <div className="card-body overflow-auto">
        <SelectSearchClient
          selectedClient={selectedClient}
          onClientSelected={onClientSelected}
          onClientSearch={onClientSearch}
        />
      </div>
      <div className="card-footer">
        <button type="button" className="btn btn-default btn-block btn-xl" onClick={onCancelClick}>
          <FormattedMessage id="cancel" />
        </button>
      </div>
    </div>
  );
}

const Div = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
`;

function Dummy() {
  return <span />;
}

const Button = styled.button`
  justify-self: start;
`;

const H5 = styled.h5`
  justify-self: center;
`;
